// @flow

import { type FeatureName, hasFeature, type Feature } from '@tectonics/prs/feature';
import { type PrsSupport, hasSupportForFeature } from '@tectonics/prs/support';

export function onlyWhenSupport(allFeatures: ImmutableArray<Feature>, prsSupport: PrsSupport): (FeatureName) => true | void {
  return (featureName: FeatureName) => {
    return (hasFeature(allFeatures, featureName) && hasSupportForFeature(prsSupport, featureName)) || undefined;
  };
}
